<template>
    <div>
        <vueHeader></vueHeader>

        <div class="banner"></div>
        

        <router-view :classify="classify"></router-view>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            active: 0,
            classify: [
                {
                    name: '医疗',
                    path: '/medicalList',
                },
                {
                    name: '健康',
                    path: '/healthList',
                },
                {
                    name: '旅行',
                    path: '/travelList',
                },
                {
                    name: '马术',
                    path: '/horseList',
                },
            ]
        }
    },

    created(){
        window.scrollTo(0,0);
    },

    mounted(){
        
    },

    methods: {
        changeTab(path){
            this.$router.replace(path)
        }
    },

    computed: {
        
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/artical.less";
.banner{
    background-image: url(./../assets/img/artical/banner.png);
}
</style>


// WEBPACK FOOTER //
// src/views/artical.vue